import React from 'react';
import { IndexRoute, Route, Redirect } from 'react-router'

import App from 'containers/App';
import HomePage from 'pages/home/HomePage';
import ICNPage from 'pages/icn/ICNPage';
import ICNPageDetails from 'pages/icn/ICNPageDetails';
import CrashDashboardPage from 'pages/crashDashboard/CrashDashboardPage';
import ICNPlusPage from 'pages/icnplus/ICNPlusPage';
import ICNPlusPageDetails from 'pages/icnplus/ICNPlusPageDetails';
import DENTPage from 'pages/dent/DENTPage';
import DENTPageDetails from 'pages/dent/DENTPageDetails';
import LoginPage from 'pages/login/LoginPage';
import NotFoundPage from 'pages/404/NotFoundPage';
import { userIsAuthenticated } from 'auth';
import * as settings from 'settings/settings';
import ReactGA from 'react-ga';

/*
    IndexRoute = root path, quando si fa richiesta di "/" (definito nel Route) allora viene eseguito il
    route IndexRoute

    attenzione:
    il component definito in Route dichiara che l' App sarà sempre caricato, indistintamente dall'url
    poi verranno caricati come suoi Props.childer i componenti che corrispondono al router richiesto,
    es "/Hopmepage" --> verrà caricato App con props.childer = HomePage component
    "/About" --> verrà caricato App con props.childer = AboutPage component
*/

/*
    check se il basename finisce con lo slash, se si viene eliminato
*/
let baseName;
if(settings && settings.baseName){
    baseName = settings.baseName.replace(/\/$/, '');;
}

function fireTracking() {
    ReactGA.pageview(window.location.pathname + window.location.search);
}

export default (
    <Route onChange={fireTracking}>
            <Route path="login" component={(LoginPage)}/>
            <Redirect exact path={baseName} to="login"  />
            <Route path="/" component={App}>
                <IndexRoute component={userIsAuthenticated(HomePage)}/>
                <Route path="crash" component={userIsAuthenticated(CrashDashboardPage)}/>
                <Route path="instantcrashalerts" component={userIsAuthenticated(ICNPage)}/>
                <Route path="instantcrashalerts/details/:id" component={userIsAuthenticated(ICNPageDetails)}/>
                <Route path="accidentreconstruction" component={userIsAuthenticated(ICNPlusPage)} />
                <Route path="accidentreconstruction/details/:id" component={userIsAuthenticated(ICNPlusPageDetails)} />
                <Route path="predictivephysicaldamage" component={userIsAuthenticated(DENTPage)} />
                <Route path="predictivephysicaldamage/details/:id" component={userIsAuthenticated(DENTPageDetails)} />
                <Route path='*' exact={true} component={NotFoundPage} />
            </Route>

    </Route>

);


// WEBPACK FOOTER //
// ./src/routes.js